import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "../Pages/Home";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Shop from "../Pages/Shop";
import ProductDetails from "../Pages/ProductDetails";
import Login from "../Pages/Login";
import Checkout from "../Pages/Checkout";
import Demo from "../Pages/Demo";
import CartPage from "../Pages/CartPage";
import Test from "../Pages/Test";
import MyAccount from "../Pages/MyAccount";
import OrderSumission from "../Pages/OderSumission";
import ShopByCategory from "../Pages/ShopByCategory";
import PrivateRoute from "../private/PrivateRoute";
import Register from "../Pages/Register";
import Purchase from "../Pages/Payment";
import Contact from "../Pages/Contact";
import BlogPage from "../Pages/BlogPage";
import SearchPage from "../Pages/SearchPage";
import OrderDetails from "../Pages/OrderDetails";
import BlogDetailsPage from "../Pages/BlogDetailsPage";
import WishListPage from "../Pages/WishlistPage";
import FacebookCallBack from "../Pages/FacebookCallBack";
import PrivacyPolicy from "../Pages/PrivacyPolicy";
import DeleteData from "../Pages/DeleteData";
import TopMarquee from "../components/TopMarquee";

const Layout = ({ children }) => {
  return (
    <>
      <TopMarquee />
      <Header />
      {children}
      <Footer />
    </>
  );
};

const Routing = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/odersubmission"
          element={
            <Layout>
              <OrderSumission />
            </Layout>
          }
        />
        <Route
          path="/"
          element={
            <Layout>
              <Home />
            </Layout>
          }
        />
        <Route
          path="/shop"
          element={
            <Layout>
              <Shop />
            </Layout>
          }
        />
        <Route
          path="/contact"
          element={
            <Layout>
              <Contact />
            </Layout>
          }
        />
        <Route
          path="/product_details/:id"
          element={
            <Layout>
              <ProductDetails />
            </Layout>
          }
        />
        <Route
          path="/login"
          element={
            <Layout>
              <Login />
            </Layout>
          }
        />
        <Route
          path="/facebook-callback"
          element={
            <Layout>
              <FacebookCallBack />
            </Layout>
          }
        />
        <Route
          path="/register"
          element={
            <Layout>
              <Register />
            </Layout>
          }
        />
        {/* <Route
          path="/cart"
          element={
            <Layout>
              <Cart />
            </Layout>
          }
        /> */}
        <Route
          path="/checkout"
          element={
            <PrivateRoute>
              <Layout>
                <Checkout />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/demo"
          element={
            <Layout>
              <Demo />
            </Layout>
          }
        />
        <Route
          path="/privacy-policy"
          element={
            <Layout>
              <PrivacyPolicy />
            </Layout>
          }
        />
        <Route
          path="/delete-data"
          element={
            <Layout>
              <DeleteData />
            </Layout>
          }
        />
        <Route
          path="/cart"
          element={
            <Layout>
              <CartPage />
            </Layout>
          }
        />
        <Route
          path="/myaccount"
          element={
            <PrivateRoute>
              <Layout>
                <MyAccount />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/test1"
          element={
            <Layout>
              <Test />
            </Layout>
          }
        />
        <Route
          path="/category/:categoryname"
          element={
            <Layout>
              <ShopByCategory />
            </Layout>
          }
        />
        <Route
          path="payment"
          element={
            <PrivateRoute>
              <Layout>
                <Purchase />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/blog"
          element={
            <Layout>
              <BlogPage />
            </Layout>
          }
        />
        <Route
          path="products"
          element={
            <Layout>
              <SearchPage />
            </Layout>
          }
        />
        <Route
          path="order-details/:id"
          element={
            <Layout>
              <OrderDetails />
            </Layout>
          }
        />
        <Route
          path="blog/:id"
          element={
            <Layout>
              <BlogDetailsPage />
            </Layout>
          }
        />
        <Route
          path="wishlist"
          element={
            <Layout>
              <WishListPage />
            </Layout>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default Routing;
